import { RootDispatch } from "@store";
import {
  ActionAddFileContract,
  ActionContractAdd,
  ActionContractDelete,
  ActionContractEdit,
  ActionContractTypes,
  ActionSetContracts,
} from "./actionTypes";

export const setContracts = (
  payload: ActionSetContracts["payload"]
): ActionSetContracts => {
  return {
    type: ActionContractTypes.SET_CONTRACTS,
    payload,
  };
};

export const deleteContract = (
  payload: ActionContractDelete["payload"]
): ActionContractDelete => {
  return {
    type: ActionContractTypes.DELETE_CONTRACT,
    payload,
  };
};

export const editContract = (
  payload: ActionContractEdit["payload"]
): ActionContractEdit => {
  return {
    type: ActionContractTypes.EDIT_CONTRACT,
    payload,
  };
};

export const addContract = (
  payload: ActionContractAdd["payload"]
): ActionContractAdd => {
  return {
    type: ActionContractTypes.ADD_CONTRACT,
    payload,
  };
};

export const addFileContract = (
  payload: ActionAddFileContract["payload"]
): ActionAddFileContract => {
  return {
    type: ActionContractTypes.ADD_CONTRACT_FILE,
    payload,
  };
};
